import { SecuredWsApi } from "@/utils/http-client";

export default {
  payAsGuest(payload) {
    return SecuredWsApi.post("/api/paymentflow/v1/guestpayment", payload);
  },
  payAsLoggedInUser(payerUserId, payload) {
    return SecuredWsApi.post(`/api/paymentflow/v1/payer/${payerUserId}/payment`, payload);
  },
};
